module.exports = __webpack_public_path__ + "assets/img_local-mission-market.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_local-mission-market.jpg
 ** module id = 127
 ** module chunks = 1
 **/